import { useListLanguageFieldsForAccountQuery } from "@generated";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";

interface Option {
  label: string;
  value: string;
}

const useListLanguageFields = () => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  let customError: string | null = null; // Declare customError

  const { data, error, isLoading, refetch, isFetching } =
    useListLanguageFieldsForAccountQuery({
      slug: accountSlug,
      filter: {
        active: true,
      },
    });

  let fields: Option[] = [];

  if (data?.data) {
    try {
      fields = data.data.map((field) => {
        if (!field.id) {
          throw new Error("Missing field.id");
        }
        if (!field.attributes?.name) {
          throw new Error("Missing field.attributes.name");
        }

        return {
          value: field.attributes?.["sow-language"] || "",
          label: field.attributes.name || "",
        };
      });
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }
  return {
    fields,
    fieldsLoading: isLoading,
    error: error ?? customError,
    refetch,
    isFetching,
  };
};
export default useListLanguageFields;
